/* eslint-disable max-len */
import { SearchOutlined } from '@ant-design/icons';
import { Col, Input, Row } from 'antd';
import React, { useContext, useEffect, useState } from 'react';

import DashboardNotificationType from 'components/atoms/DashboardNotification';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import { Context } from 'components/hoc/Store';
import DashboardCard from 'components/molecules/DashboardCard';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';
import usePageName from 'hooks/usePageName';
import useProfily from 'hooks/useProfily';

import profilyApi, { IPristupy } from 'services/profily';

import routePathEnum from 'enums/routePathEnum';

import getLanguageObject from 'utils/getLanguageObject';

const DetailUctu: React.FC = () => {
    const { ucty, language, profily } = useContext(Context);
    const [searching, setSearching] = useState<boolean>(false);
    const { setLevel } = useProfily();
    const [profiles, setProfiles] = useState<IPristupy[]>([]);
    const [searchValue, setSearchValue] = useState<string>('');
    const { navigateWorkaround } = useNavigateWorkaround();
    const detailUctuTyp = usePageName();

    useEffect(() => {
        /* funkcionalita filtru api sa zavola po 900ms bez inputu alebo hned 
        ak input === '' */
        let delayDebounceFn: ReturnType<typeof setTimeout>;

        delayDebounceFn = setTimeout(
            () => {
                setSearching(true);
                profilyApi(searchValue).then(({ data }) => {
                    setLevel('profily', data);
                    setLevel('ucty', data.sezpristupu!);
                    setProfiles(data.sezpristupu!);
                    setSearching(false);
                    if (data.sezpristupu!.length === 0 && profily?.typprihlaseni !== 'DLT') {
                        navigateWorkaround(routePathEnum.NOVY_UCET);
                    }
                });
            },
            searchValue ? 900 : 0
        );

        return () => clearTimeout(delayDebounceFn);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchValue]);

    return (
        <>
            <DashboardNotificationType profily={profiles} />
            <Row>
                <Col span={24}>
                    <Title
                        level={4}
                        text={`SPRAVOVANE_${detailUctuTyp}`}
                        style={{
                            color: '#808585'
                        }}
                    />
                    <Input.Search
                        placeholder={getLanguageObject(language).MAIN_PAGE_FILTER_PLACEHOLDER}
                        allowClear={true}
                        enterButton={getLanguageObject(language).VYHLEDAT}
                        size="large"
                        onChange={ev => setSearchValue(ev.target.value)}
                        bordered={false}
                        loading={searching}
                        style={{
                            backgroundColor: 'white',
                            border: '1px solid #D4D6D6',
                            padding: '5px',
                            borderRadius: 6
                        }}
                        id="searchInput"
                        className="search-input"
                        prefix={<SearchOutlined style={{}} />}
                    />
                </Col>
            </Row>
            {!(ucty || profiles).length && <Paragraph text="SPRAVOVANE_PRAVICKE_ZADNE_TEXT" />}
            <DashboardCard profily={ucty || profiles} isDetailUctu={true} />
        </>
    );
};

export default DetailUctu;
